
import React from 'react'
import { TranslationComponent } from '../../Translation/cont/Translation'


const NewsletterTranslation = ({id, translation, children, before="", after="", uppercase=false}) => {
    const { currentLang, debug, strings } = translation
    const translationStrings =  strings && strings.hasOwnProperty(id) ? translation.strings[id] : null

    return <TranslationComponent
        id={id}
        currentLang={currentLang}
        translationStrings={translationStrings}
        debug={debug}
        children={children} 
        type = 'string'
        before={before}
        after={after}
        uppercase={uppercase}
    />
}


export default NewsletterTranslation